module.exports = __webpack_public_path__ + "static/media/left-arrow-2.bf744005.png";